<template>
  <div>
    <v-autocomplete
      v-model="selectedOptions"
      :items="options"
      chips
      :label="$t('Select options')"
      multiple
      :value="selectedOptions"
      return-object
    >
      <template v-slot:selection="data">
        <v-chip
          outlined
          exact
          small
          close
          close-icon="mdi-close"
          v-bind="data.attrs"
          :input-value="data.name"
          @click:close="remove(data.item)"
          v-if="data.item.name"
          class="body-2"
        >
          <span>
            ({{ data.item.addedPrice }}€)
            <strong>{{ data.item.name }}</strong>
          </span>
        </v-chip>
      </template>
      <template v-slot:no-data> <div /></template>
      <template v-slot:append-item>
        <template>
          <v-list-item-content>
            <v-btn color="primary" text @click="addOption = true"
              >Create new</v-btn
            >
          </v-list-item-content>
        </template>
      </template>
      <template v-slot:item="data">
        <template>
          ({{ data.item.addedPrice }}€)
          <v-list-item-content>
            <strong>
              <v-list-item-title>{{ data.item.name }}</v-list-item-title>
            </strong>
          </v-list-item-content>
        </template>
      </template>
    </v-autocomplete>
    <v-dialog v-model="addOption" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">New Option</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="10">
                <v-text-field
                  autofocus=""
                  label="Name"
                  v-model="newOptionName"
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-text-field
                  label="Price"
                  type="number"
                  suffix="€"
                  step="0.01"
                  v-model="newOptionPrice"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="addOption = false">Close</v-btn>
          <v-btn
            color="primary"
            text
            @click="
              createOption();
              addOption = false;
            "
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Option from "@/model/option";
export default {
  name: "Options",
  props: ["productOptions"],
  data() {
    return {
      newOptionName: "",
      newOptionPrice: 0,
      addOption: false,

      selectedOptions: []
    };
  },
  computed: {
    options() {
      return this.$store.getters.restaurant.options;
    }
  },
  methods: {
    createOption() {
      let option = new Option({
        name: this.newOptionName,
        addedPrice: Number(this.newOptionPrice)
      });
      this.selectedOptions.push(option);
      this.$store.getters.restaurant.options.push(option);
      this.$store.getters.restaurant.save();
      this.newOptionName = "";
      this.newOptionPrice = 0;
    },

    remove(item) {
      this.selectedOptions = this.selectedOptions.filter(
        option => option.name !== item.name
      );
    }
  },

  watch: {
    selectedOptions: function() {
      this.$emit("updateOptions", this.selectedOptions);
    },
    productOptions: function() {
      this.selectedOptions = this.productOptions;
    }
  }
};
</script>
